<template>
  <div style="background-color: #fff;">
    <div class="productImgContainer">
      <img class="productImg" :src="productImgSrc">
    </div>
    <div class="rj45">
      <div>
        <ul class="navBar">
          <router-link to="/" tag="li"><a> GSMAKE <span style="padding-left:20px;">&gt;</span></a></router-link>
          <router-link to="/product/type" tag="li"><a> Product <span style="padding-left:20px;">&gt;</span></a></router-link>
          <router-link to="" tag="li"><a style="color: #2888ED;"> {{productType.name}} </a></router-link>
        </ul>
      </div>

      <h2>{{productType.name}} FEATURES</h2>
      <div class="feature">
        <div>
          <div class="description">
            <ul>
              <li v-for="(feature,index) in productType.featureList" :key="'feature' + index"> {{feature.value}} </li>
            </ul>
          </div>
          <div class="descriptionImg">
            <img :src="productType.mainImageUrl">
          </div>
        </div>
      </div>

      <h2>PRODUCTS</h2>
      <div slot="page1" v-if="productList.length>0">
      <div class="item" v-for="(product, indexItm) in productList" :key="'productList' + indexItm">
        <div class="itemList">
          <h3>{{ product.name }}</h3>
          <p>{{ product.tagKeywords }}</p>
          <br>
          <h3>Description</h3>
          <ul>
            <li v-for="(description,indexDes) in product.descriptionList" :key="'descriptionList' + indexDes">{{ description.value }}</li>
          </ul>
        </div>
        <div class="itemImg">
          <img :src="product.mainImageUrl">
        </div>
        <div class="itemNav">
          <ul>
            <li><a @click="drawShow(product)"> View Product Draw </a></li>
            <li><a  @click="detailShow(product)"> Technical Details </a></li>
            <li><a> Configure a Free Samples </a></li>
            <li><a> Contact & Inquiries </a></li>
          </ul>
        </div>
        <div class="itemDraw" v-if= "drawShowIndex === product">
          <div class="itemDrawContainer">
            <span class="fa fa-times fa-2x drawClose" aria-hidden="true"
                  @click="drawShowIndex = !drawShowIndex"
            ></span>
            <img :src="product.productDrawUrl">
            <p>*Please contact us to require product details</p>
          </div>
        </div>
        <div class="itemDetails" v-if="detailShowIndex === product">
          <div class="detailsContainer">
            <table border="1" cellspacing="0" cellpadding="0">
              <tr>
                <th colspan="2" align="left" height="30px">
              <span class="fa fa-times fa-2x drawClose" aria-hidden="true"
                    @click="detailShowIndex = !detailShowIndex"
              ></span>
                </th>
              </tr>
              <tr>
                <th colspan="2" align="left" height="30px">Electrical Characteristics:</th>
              </tr>
              <tr v-for="(detailsEle, indexEle) in product.technicalDetailList" :key="'Ele' + indexEle">
                <td>{{ detailsEle.subEle }}</td>
                <td>{{ detailsEle.valEle }}</td>
              </tr>
              <tr>
                <th colspan="2" align="left" height="30px">Material:</th>
              </tr>
              <tr v-for="(detailsMat, indexMat) in product.technicalDetailList" :key="'Mat' + indexMat">
                <td>{{ detailsMat.subMat }}</td>
                <td>{{ detailsMat.valMat }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      </div>

<!--      <div style="margin: 0; padding: 0">-->
        <div class="pageContainer">
          <ul class="pageInner">
            <li class="page" @click="preOrNext(-1)"><span class="fa fa-chevron-left" aria-hidden="true"></span></li>
            <li class="page"
                v-for="(item, indexPage) in pages"
                :key="'page' + indexPage"
                :class="{actived: item === currentPage }"
                @click="select(item)"
            >
              <span>{{ item }}</span>
            </li>
            <li class="page" @click="preOrNext(1)"><span class="fa fa-chevron-right" aria-hidden="true"></span></li>
          </ul>
        </div>
<!--      </div>-->
    </div>
  </div>
</template>

<script>
  import { getProductList , getMainProductType } from '@/api/product'

  export default {
    data() {
      return {
        productImgSrc: require('@/assets/pgm/product-header-rj45.jpg'),
        productType: {},
        productList: [],
        detailShowIndex: null,
        drawShowIndex: null,
        productTypeId: '',
        currentPage: 1,
        totalPages: 8,
        pageSize: 6,
        form: {
          // ids: '',
          productTypeId: '',
          pageNum: 1,
          pageSize: 6,
        }
      }
    },
    components: {
    },
    computed: {
      pages() {
        const t = this.totalPages
        const c = this.currentPage
        let arry1 = [];
        if( t >=10 ) {
          if(c <=5) {
            return [1,2,3,4,5,6,7,8,'...',t]
          }else if(c >=t-4 ) {
            return [1,'...',t-7,t-6,t-5,t-4,t-3,t-2,t-1,t]
          }else {
            return [1,'...',c-2,c-1,c,c+1,c+2,c+3,'...',t]
          }
        } else {
          for (let i=1; i<=t; i++){
            arry1.push(i);
          } return(arry1)
        }
      }
    },
    watch: {
      '$route.query.typeId': function (newVal, oldVal) {
        this.productList = []
        this.fetchData()
      }
    },
    created() {
      this.productList = []
      this.fetchData()
    },
    methods: {
      async fetchData() {
        this.form.productTypeId = this.$route.query.typeId
        const { data } = await getProductList(this.form)
        this.productList = data.list
        this.totalPages = Math.ceil(data.total/this.pageSize)
        this.productList.forEach((item,index)=>{
          if (item.description) {
            item.descriptionList = JSON.parse(item.description)
          }
          if (item.technicalDetails) {
            item.technicalDetailList = JSON.parse(item.technicalDetails)
          }
        })
        if (this.productTypeId){
          if (this.productTypeId !== this.form.productTypeId) {
            this.refreshProductType(this.form.productTypeId)
          }
        }else {
          this.refreshProductType(this.form.productTypeId)
        }
      },
      async refreshProductType(typeId) {
        const { data } = await getMainProductType({id:typeId})
        data.featureList = JSON.parse(data.feature)
        this.productType = data
        this.productTypeId = typeId
      },
      select(n) {
        if (n === this.currentPage) return
        if (typeof n === 'string') return
        this.currentPage = n
        this.form.pageNum = n
        this.fetchData()
        document.documentElement.scrollTop = 400
      },
      preOrNext(n) {
        this.currentPage += n
        this.currentPage < 1 ?
                (this.currentPage = 1)
                :
                this.currentPage > this.totalPages ?
                        (this.currentPage = this.totalPages)
                        :
                        null
        this.form.pageNum = this.currentPage
        this.fetchData()
        document.documentElement.scrollTop = 400
      },
      drawShow(listRj45) {
        this.drawShowIndex = listRj45
        this.detailShowIndex = false
      },
      detailShow(listRJ45) {
        this.detailShowIndex = listRJ45
        this.drawShowIndex = false
      },
    }
  }


</script>

<style scoped>

@font-face {
  font-family: 'font-awesome';
  src: url("../../../public/static/fontAwesome/font-awesome-4.7.0/fonts/FontAwesome.otf");
}

*{
  font-family: "MuseoSans-300","font-awesome", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin:0;
  padding: 0;
}

.productImgContainer {
  padding-top: 89px;
  /*height: 290px;*/
  min-width: auto;
  max-height: 290px;
  max-width: 1900px;
  margin: 0 auto;
  /*float: left;*/
}

.productImg {
  /*margin-top: 89px;*/
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.rj45 {
  max-width: 1200px;
  min-width: 700px;
  margin: 0 auto;
  padding: 4% 6%;
  display: table;
  /*height: 1300px;*/
  /*border: 1px solid black;*/
}

.navBar {
  padding-left: 1%;
  font-size: 14px;
}

.navBar li {
  display: block;
  padding-left: 10px;
  float: left;
  color: #2f2f2f;
}

.navBar li:hover {
  color: #2888ED;
}

.navBar li a {
  text-decoration: none;
  color: inherit;
  display: block;
}

h2 {
  padding-top: 5%;
  float: left;
  margin:0 2% 3% 2%;
  width: 100%;
  border-bottom: 2px solid gray;
  font-size: 24px;
  color: #7a7a7a;
}

.feature {
  display: block;
  float: left;
  padding-left: 3.5%;
}

.description {
  float: left;
  min-width: 300px;
  width: 60%;
}

.description li {
  padding: 8px 0;
}

.descriptionImg {
  float: right;
  min-width: 200px;
  width: 35%;
}

.descriptionImg img {
  width: 100%;
  position: relative;
}

.item {
  display: block;
  float: left;
  padding-left: 3.5%;
  border-bottom: 2px solid gray;
  padding-bottom: 2%;
  padding-top: 2%;
  min-width: 800px;
  width: 100%;
}

h3 {
  padding-bottom: 10px;
  color: #2d4e7d;
}

.itemList {
  float: left;
  min-width: 280px;
  width: 40%;
}

.itemList li {
  padding: 5px 0;

}

.itemImg {
  display: block;
  float: left;
  min-width: 200px;
  width: 25%;
}

.itemImg img {
  width: 100%;
  position: relative;
  padding:5% 2%;
}

.itemNav {
  padding: 50px 20px;
  float: right;
  min-width: 200px;
  width: 30%;
  font-size: 14px;
}

.itemNav li {
  display: block;
  border: 1px solid gray;
  border-radius: 5px;
  text-align: center;
  margin: 5px 0;
  background-color: #337ab7;
  color: #f2f2f2;
}

.itemNav li:hover {
  background-color: #275e8d;
}

.itemNav li a{
  display: block;
  padding: 5% 0;
  text-decoration: none;
  color: inherit;
}

.pageContainer {
  float: left;
  width: 100%;
  min-width: 800px;
}

.pageInner {
  display: block;
  width: 650px;
  margin: 30px auto;
}

.page{
  float: left;
  display: block;
  text-align: center;
  line-height: 20px;
  width: 20px;
  padding: 10px;
  margin: 0 5px;
  border: 1px solid gray;
  border-radius: 5px;
}

.page:hover {
  box-shadow: 1px 1px 5px #7a7a7a;
}

.actived {
  border-color: #2d8cf0;
  background-color: #2d8cf0;
  color: #f2f2f2;
}

.itemDraw {
  width: 800px;
  height: 500px;
  top: 300px;
  float: left;
  position: fixed;
  margin: 0 auto;
  background:rgba(0,0,0,0.2);
  z-index: 10;
}

.itemDrawContainer {
  margin: 10px auto;
  width: 500px;
  font-weight: bold;
}

.itemDrawContainer img {
  width: 100%;
  height: 100%;
}

.drawClose {
  float: left;
  color: #f96057
}

.drawClose:hover {
  text-shadow: #2f2f2f 0 0 5px;
}

.itemDetails {
  width: 800px;
  height: 500px;
  top: 300px;
  float: left;
  position: fixed;
  margin: 0 auto;
  background:rgba(0,0,0,0.2);
  z-index: 10;
}

.detailsContainer table {
  background-color: white;
  width: 600px;
  margin: 10px auto;
  border-collapse: collapse;
}

td {
  padding: 3px;
}

</style>